import * as React from "react";
import {Option} from "ts-option";
import PageHeaderView from "../../body/PageHeaderView";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import PageContentView from "../../body/PageContentView";
import Loading from "../../ui/loading/Loading";
import {Boxed} from "../../../hiberUiKit/src/molecules/Boxed/Boxed";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import StringSortableTable from "../common/StringSortableTable";

interface ComponentProps {
	/**
	 * Update sidebar order
	 * @param {string[]} sidebarOrder
	 */
	updateSidebarOrder: (sidebarOrder: string[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Page title
	 */
	pageTitle: string;
	/**
	 * Sidebar order list.
	 */
	sidebarOrder: Option<string[]>;
	/**
	 * Sidebar map
	 * @param {string} item
	 * @returns {string}
	 */
	sidebarMap: any
}

interface IState {
	/**
	 * Indicates if sort order has changed.
	 */
	isDirty: boolean;
	/**
	 * Items with new sort order.
	 */
	sidebarOrder: string[];
	/**
	 * Indicates if actions is ongoing
	 */
	isLoading: boolean;
}

export default class SidebarConfig extends React.Component<ComponentProps, IState> {

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			isDirty: false,
			sidebarOrder: [],
			isLoading: false
		};
	}

	render() {
		return (
			<Boxed>
				<PageHeaderView header={this.props.pageTitle}>
					<ButtonGroupWrapper>
						<ButtonPrimary onClick={() => this.updateSidebarOrder(this.state.sidebarOrder)}
									   disabled={this.props.sidebarOrder.isEmpty || !this.state.isDirty}
									   isLoading={this.state.isLoading}
									   label={"Save Changes"}
									   variant={"burgundy"}/>
					</ButtonGroupWrapper>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.props.sidebarOrder.isEmpty}>
						<StringSortableTable items={this.props.sidebarOrder.getOrElse([])}
											 onOrderChange={this.onOrderChange}
											 renderHeaderBody={this.renderHeaderBody}
											 renderRowBody={this.renderRowBody}/>
					</Loading>
				</PageContentView>
			</Boxed>
		)
	}

	updateSidebarOrder(sidebarOrder: string[]) {
		this.setState({isLoading: true}, () => {
			this.props.updateSidebarOrder(sidebarOrder,
				() => this.setState({isDirty: false, isLoading: false}),
				() => this.setState({isLoading: false}));
		});
	}

	/**
	 * Sort order change callback.
	 * @param {string[]} items
	 */
	onOrderChange = (items: string[]) => {
		this.setState({sidebarOrder: items, isDirty: true});
	};

	/**
	 * Header renderer
	 */
	renderHeaderBody = () => {
		return (
			<th>Sidebar item</th>
		)
	};
	/**
	 * Row item renderer
	 * @param item
	 */
	renderRowBody = (item: string) => {
		return (
			<td>{this.props.sidebarMap[item] ? this.props.sidebarMap[item] : item}</td>
		)
	};
}